(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["about-us-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
     var buttons = document.querySelectorAll('#slider-controls .slider-button');
     var slides = document.querySelectorAll('.slide');

     buttons.forEach(function(button, index) {
       button.addEventListener('click', function() {
         slides.forEach(function(slide) {
           slide.classList.remove('active');
         });

         buttons.forEach(function(button) {
           button.classList.remove('active');
         });

         button.classList.add('active');
         slides[index].classList.add('active');
       });
     });
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Formular-2024"] && !window.DesignMode) return;
  try {
    

document.getElementById('contact_form').addEventListener('submit', function(event) {
  const receiptDateValue = document.getElementById('ContactForm-receipt-date').value;
  const receiptDate = new Date(receiptDateValue);
  const currentDate = new Date();
  const diffTime = Math.abs(currentDate - receiptDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  const successMessage = document.getElementById('contact-form-success-message');
  const errorMessage = document.getElementById('contact-form-error-message');
  const warningMessage = document.getElementById('contact-form-warning-message');

  successMessage.style.display = 'none';
  errorMessage.style.display = 'none';
  warningMessage.style.display = 'none';

  if (diffDays > 21) {
    errorMessage.style.display = 'block';
    alert('Unfortunately your return period has expired, we are very sorry, but unfortunately there is nothing more we can do in your case.');
    event.preventDefault();
  } else if (diffDays > 14) {
    warningMessage.style.display = 'block';
    alert('Unfortunately, your return period has expired, but we will still review your request.');
  } else {
    successMessage.style.display = 'block';
    alert('Thank you for your message. We will get back to you as soon as possible.');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-2"] && !window.DesignMode) return;
  try {
    
var mql = window.matchMedia('(max-width: 767px)');
var desktopVideoDiv = document.querySelector('.desktop-video');
var mobileVideoDiv = document.querySelector('.mobile-video');

// Zugreifen auf die URLs über die Blockeinstellungen
var mobileVideoUrl = '{{ block.settings.video_mobile }}';
var desktopVideoUrl = '{{ block.settings.video }}';

function handleViewportChange(mql) {
  // Entfernt vorhandenes Video, falls vorhanden
  while (desktopVideoDiv.firstChild) {
    desktopVideoDiv.firstChild.remove();
  }
  while (mobileVideoDiv.firstChild) {
    mobileVideoDiv.firstChild.remove();
  }

  // Erstellt und hinzufügt das Video basierend auf der Bildschirmgröße
  var video = document.createElement("video");
  video.setAttribute("loop", "");
  video.setAttribute("muted", ""); // Das Video wird stummgeschaltet
  video.setAttribute("playsinline", ""); 

  if (mql.matches) {
    video.setAttribute("src", mobileVideoUrl);  // Verwenden der URL aus den Blockeinstellungen
    mobileVideoDiv.appendChild(video);
  } else {
    video.setAttribute("src", desktopVideoUrl);  // Verwenden der URL aus den Blockeinstellungen
    desktopVideoDiv.appendChild(video);
  }

  // Versucht, das stummgeschaltete Video abzuspielen, und behandelt mögliche Fehler
  video.play()
    .then(_ => {
      // Autoplay hat begonnen.
    })
    .catch(error => {
      // Autoplay wurde verhindert.
      console.log('Autoplay verhindert:', error);
    });
}

handleViewportChange(mql);  // Aufruf beim Laden der Seite
mql.addListener(handleViewportChange); // Fügt einen Event Listener hinzu

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-card"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
     $('.image-slider').slick({
       infinite: false,
       slidesToShow: 5, /* Anzahl der zu zeigenden Slides geändert */
       slidesToScroll: 1,
       responsive: [
         {
           breakpoint: 768,
           settings: {
             slidesToShow: 1,
             slidesToScroll: 1,
             infinite: false,
             dots: true
           }
         }
       ]
     });
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-cards"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.image-slider-wrapper').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 767,
          settings: "unslick"
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selfie-mobil-fokus"] && !window.DesignMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  const swiper = new Swiper('.swiper-container', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slide-section-with-bg-color"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
     var buttons = document.querySelectorAll('#slider-controls .slider-button');
     var slides = document.querySelectorAll('.slide');

     buttons.forEach(function(button, index) {
       button.addEventListener('click', function() {
         slides.forEach(function(slide) {
           slide.classList.remove('active');
         });

         buttons.forEach(function(button) {
           button.classList.remove('active');
         });

         button.classList.add('active');
         slides[index].classList.add('active');
       });
     });
   });

  } catch(e) { console.error(e); }
})();
      })();
